enum SeedTrackerRoutes {
  List = '/seedtracker',
  SeedInventoryList = '/seedtracker/seed-inventory/:id',
  SeedInventoryAdd = '/seedtracker/seed-inventory/:id/add',
}

export default SeedTrackerRoutes
